module.exports = __webpack_public_path__ + "img/ontick_login_bg.02a50609.jpg";